export default function GuaranteeCard() {
  return (
    <div className="mz-gar">
      <div className="mz-gar-seal" aria-hidden>
        <svg viewBox="0 0 80 80" width="56" height="56" fill="none">
          {/* Selo redondo manuscrito */}
          <circle cx="40" cy="40" r="36" stroke="currentColor" strokeWidth="2.2" fill="rgba(255,145,77,0.08)" strokeDasharray="2 3" opacity="0.7" />
          <circle cx="40" cy="40" r="28" stroke="currentColor" strokeWidth="1.5" fill="none" />
          <path
            d="M 26,40 L 36,50 L 56,30"
            stroke="currentColor"
            strokeWidth="3.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      </div>

      <div className="mz-gar-text">
        <div className="mz-gar-eyebrow">Promessa nossa, da equipe Inspira</div>
        <div className="mz-gar-title">Se você não amar, devolvemos seu dinheiro.</div>
        <div className="mz-gar-body">
          Sete dias pra ouvir com calma, mostrar pra família, decidir. Se não ficar como
          imaginou, a gente <strong>refaz sem custo</strong> — ou devolve o valor integral, sem letrinha miúda.
        </div>
      </div>

      <style>{`
        .mz-gar {
          margin: 0 16px 22px;
          padding: 20px 20px 22px;
          background:
            linear-gradient(180deg, rgba(255,253,248,0.85) 0%, rgba(252,243,230,0.95) 100%),
            radial-gradient(ellipse 80% 60% at 15% 12%, rgba(255,145,77,0.10) 0%, transparent 70%);
          border: 1.5px solid rgba(204,102,32,0.20);
          border-radius: 16px;
          display: grid;
          grid-template-columns: 56px 1fr;
          gap: 16px;
          align-items: start;
          box-shadow: 0 4px 18px -8px rgba(80,40,10,0.16);
        }

        html[data-theme='dark'] .mz-gar {
          background:
            linear-gradient(180deg, rgba(255,145,77,0.06) 0%, rgba(255,145,77,0.10) 100%);
          border-color: rgba(255,145,77,0.24);
        }

        .mz-gar-seal {
          color: var(--gold);
          flex-shrink: 0;
        }

        .mz-gar-text {
          min-width: 0;
        }

        .mz-gar-eyebrow {
          font-family: 'DM Sans', sans-serif;
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--amber-deep);
          margin-bottom: 6px;
        }

        .mz-gar-title {
          font-family: 'Playfair Display', 'Source Serif 4', serif;
          font-weight: 700;
          font-style: italic;
          font-size: clamp(18px, 4.6vw, 22px);
          line-height: 1.2;
          letter-spacing: -0.015em;
          color: var(--heading-ink);
          margin-bottom: 10px;
        }

        .mz-gar-body {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          line-height: 1.55;
          color: var(--text-body);
          font-weight: 400;
        }
        .mz-gar-body strong {
          color: var(--amber-deep);
          font-weight: 700;
        }

        @media (min-width: 720px) {
          .mz-gar { margin: 0 auto 26px; max-width: 660px; padding: 24px 26px; }
        }
      `}</style>
    </div>
  );
}
